module.exports = __webpack_public_path__ + "static/media/paisagemudf-pg.4b16f6bb.jpg";